import I18n from "i18n-js";
import React from "react";
import { func, shape } from "prop-types";
import { connect } from "react-redux";
import { ROUTE_PRESSURE_GAUGE } from "../../../routes";
import {
  updatePressureGauge,
  getPressureGaugeInfos,
} from "../actions/pressureGaugesActions";
import FormPage from "../../common/components/layout/FormPage";
import CreatePressureGaugeForm from "../components/CreatePressureGaugeForm";

class UpdatePressureGauge extends FormPage {
  static propTypes = {
    pressureGauge: shape().isRequired,
    match: shape().isRequired,
    getPressureGaugeInfos: func.isRequired,
    updatePressureGauge: func.isRequired,
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * {@inheritdoc}
   */
  componentDidMount() {
    const { getPressureGaugeInfos, match } = this.props;

    getPressureGaugeInfos(match.params.uuid);
  }

  /**
   * @param {object} pressureGauge
   */
  onSubmit(pressureGauge) {
    const { updatePressureGauge, match } = this.props;

    updatePressureGauge(match.params.uuid, pressureGauge);
  }

  /**
   * {@inheritdoc}
   */
  getTitle() {
    return I18n.t("pages.pressure_gauges.update.title");
  }

  /**
   * {@inheritdoc}
   */
  getBackRoute() {
    return ROUTE_PRESSURE_GAUGE;
  }

  /**
   * {@inheritdoc}
   */
  renderContent() {
    const { pressureGauge } = this.props;

    return (
      <CreatePressureGaugeForm
        loading={pressureGauge.saving}
        infos={pressureGauge.infos}
        onSubmit={this.onSubmit}
      />
    );
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { pressureGauge } = this.props;

    if (pressureGauge.infos === undefined) {
      return <div className="loader" />;
    }

    if (pressureGauge.infos === null) {
      return <p>{I18n.t("pages.pressure_gauges.update.unknown")}</p>;
    }

    return super.render();
  }
}

const mapStateToProps = (state) => ({
  pressureGauge: state.pressureGauge,
});

const mapDispatchToProps = (dispatch) => ({
  getPressureGaugeInfos: (uuid) => dispatch(getPressureGaugeInfos(uuid)),
  updatePressureGauge: (uuid, ) =>
    dispatch(updatePressureGauge(uuid, )),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePressureGauge);
